// src/styles/minimalStyles.js (Example - Ensure this exists and is correct)
export const colors = {
  primaryText: '#333',
  secondaryText: '#6b7280',
  border: '#e5e7eb', // Lighter border than previous #e5e5e5
  backgroundLight: '#f8f9fa',
  white: '#ffffff',
  accent: '#007bff', // Blue accent
  accentDark: '#0056b3',
  darkBlue: '#1a2a6c', // Example dark blue
  lightBlue: '#e7f0ff', // Example light blue bg
  error: '#dc3545',
  orange: 'rgb(230, 126, 34)', // Added from header
};

export const typography = {
  fontFamily: "'Helvetica', Arial, sans-serif",
  baseSize: '1rem',
  largeTitleSize: '2.5rem', // 40px
  h1Size: '2.25rem', // 36px
  h2Size: '1.75rem', // 28px
  h3Size: '1.375rem', // 22px
  smallSize: '0.875rem', // 14px
  normalWeight: 'normal',
  mediumWeight: '500',
  boldWeight: '600', // Slightly less bold than 700
};

export const layout = {
  maxWidth: '1100px', // Max width for article content area
  contentMaxWidth: '750px', // Max width for readable text column
  containerPadding: '0 20px',
  sectionSpacing: '40px',
  gap: '20px',
};

export const commonStyles = {
  container: {
    maxWidth: layout.maxWidth,
    margin: '0 auto',
    padding: layout.containerPadding,
    fontFamily: typography.fontFamily,
    color: colors.primaryText,
    boxSizing: 'border-box',
  },
  section: {
    marginBottom: layout.sectionSpacing,
    paddingBottom: layout.sectionSpacing,
    borderBottom: `1px solid ${colors.border}`
  },
  sectionTitle: { // For References, Recommended etc.
    fontSize: typography.h2Size,
    fontWeight: typography.mediumWeight,
    color: colors.primaryText,
    marginBottom: '25px',
    paddingBottom: '10px',
    borderBottom: `1px solid ${colors.border}`,
  }
};